// getWishItems returns a list of wishItem (object)
// for the given wishItems state.
const getWishItems = ({ ids = [], data = {} }) => ids.map(id => data[id]);

export { getWishItems };
